module.exports = __webpack_public_path__ + "img/033-attitude.e4320ac3.svg";